import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {UtilService, ResponseHttpError, ResponseHttpSuccess, CustomMessageService} from "library";
import {SalesWorkflowService} from "../../../services/api/v1/sales-workflow.service";
import {SalesWorkflowSteps} from "../../../enums";

@Component({
  selector: 'app-sales-category',
  templateUrl: './sales-category.component.html'
})
export class SalesCategoryComponent implements OnInit{
  requestId: any;
  categoryList: any[] = [];
  selectedCategory: any;
  categories = signal<any>([]);
  noImage = 'assets/noImage.jpg';
  path!: string
  flowCode: string;
  isListView = false;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();
  readonly categoryCode = this.route.snapshot.params['category_code'];
  data = signal<any>({});

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private salesWorkflowService: SalesWorkflowService,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private pathNavigationService: PathNavigationService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.path = this.route.snapshot.params['path'];
    this.flowCode = this.route.snapshot.params['flow_code'];
  }

  ngOnInit() {
    this.load();
    this.data.set(this.requestService.request);

  }

  toggleView(): void {
    this.isListView = !this.isListView;
  }

  load(){
    this.utilService.enablePageLoading();
    this.requestService.getCategoriesList(this.requestId).subscribe({
      next: ( resp: ResponseHttpSuccess   )=>{
        if (resp.status === HttpStatusCode.Ok) {
          if(resp.body.data.list.length == 0) {
            this.handleRequestNotApproved('El cliente no califica a ningun producto [FE]')
          }else {
            this.categoryList = resp.body.data.list;
            this.categories.set(this.categoryList);
          }
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError)=>{
        this.utilService.disablePageLoading()
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  save(category: any) {
    this.selectedCategory = category;
    let data = { category_id: category.id}
    this.requestService.update(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if (resp.status == HttpStatusCode.NoContent){
          this.requestService.categoryId = category.id
          this.utilService.enablePageLoading();
          let data = {
            requestId: this.requestId,
            categoryCode: category.code
          }
          this.onNextStep(data)
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (err: HttpErrorResponse) => {
        if ( err.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(err as any);
        }else{
          this.customMessageService.responseNoticeHandler(err);
        }
      }
    });
  }

  onGotoStep(stepNavigator: { flowCode: string, stepCode: string }) {
    this.gotoStepEvent.emit(stepNavigator);
  }

  onGoToPrueba(stepCode: keyof typeof SalesWorkflowSteps) {
    console.log(stepCode);
    this.router.navigate([this.salesWorkflowService.buildUrl({
      flowCode: 'general',
      path: this.salesWorkflowService.getUrlStepByCode(SalesWorkflowSteps[stepCode]).path,
      requestId: this.route.snapshot.params['request_id'],
    })]);
  }


  onNextStep(data: any){
    this.nextStepEvent.emit(data);
  }

  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.utilService.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }

  private handleRequestNotApproved(messageError: string): void {
    const attemptedUrl = this.utilService.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotApproved(this.flowCode, state);
  }
}
